import {Component} from "react";
import * as React from "react";
import {
    BUDGET_PROPORTIONAL_DAILY_INDICATOR, COST_VS_PROJECTED_INDICATOR,
    CURRENT_PERIOD_COST_VS_TIME_COMPLETION_INDICATOR,
    CONVERSIONS_DAILY_INDICATOR, CPA_INDICATORS, CURRENT_ROAS_VS_LAST_MONTH, CURRENT_ACOS_VS_LAST_MONTH,
    ODS_VS_YESTERDAY_INDICATOR, ODS_VS_TODAY_INDICATOR, ODS_VS_LAST_7_DAYS_INDICATOR, ODS_VS_PLATFORM_BUDGET_INDICATOR, FUNDS_INDICATOR,
    GOAL_1_INDICATOR, GOAL_2_INDICATOR, EXCEED_BUDGET_INDICATOR
} from "../../../indicators";
import {Switch} from "../../buttons/Swtich";
import {AGENCY_FLEX_INDICATOR} from "../../dashboard/columns";
import { withTranslation } from 'react-i18next';

class TwoLevelIndicatorSensitivityComponent extends Component {
    constructor(props) {
        super(props);
        this.handleMediumSensitivityChange = this.handleMediumSensitivityChange.bind(this);
        this.handleHighSensitivityChange = this.handleHighSensitivityChange.bind(this);
        this.handleStatusChange = this.handleStatusChange.bind(this);

    }

    render() {
        return (
            <div key={this.props.indicatorName} className="form-item" style={{marginBottom:"0.7em"}}>
                <div className="toggle-input-header" style={{height:"3.3em"}}>
                    <Switch onChange={this.handleStatusChange} checked={this.props.isActive}/>
                    <div className="combined-label">
                        <p className="combined-label-title">{this.props.indicatorTitle}</p>
                        <p className="combined-label-subtitle">{this.props.indicatorSubtitle}</p>
                    </div>
                </div>
                <div className="form-grid row-col-2" style={{paddingRight:"40px"}}>
                    {this.renderLevelSensitivities()}
                </div>
            </div>
        )
    }

    renderLevelSensitivities() {
        if (this.indicatorIsConversionsOrCPA()) {
            return this.renderSensitivitiesForIndicatorsWithGoodAndBad();
        } else if (this.indicatorIsBudgetOrODS()) {
            return this.renderSensitivitiesForBudgetOrODS();
        } else if(this.indicatorIsFunds()) {
            return this.renderSensitivitiesForFunds();
        } else if (this.indicatorIsGoals()) {
            return this.renderSensitivitiesForIndicatorsWithGoodAndBad();
        } else if (this.indicatorIsFlexIndicator()) {
            return this.renderSensitivitiesForIndicatorsWithGoodAndBad();
        }
    }

    badSensitivityValue() {
        return this.sensitivityValueForLevel('BAD')
    }

    criticSensitivityValue() {
        return this.sensitivityValueForLevel('CRITIC')
    }

    sensitivityValueForLevel(levelName) {
        let result = null;
        this.props.sensitivityValues.forEach(sensitivityValue => {
            if (sensitivityValue.level === levelName) {
                result = sensitivityValue.value;
            }
        });
        return result
    }

    renderSensitivitiesForBudgetOrODS() {
        let badSensitivityValue = this.badSensitivityValue(this.props.indicatorName);

        let criticSensitivityValue = this.criticSensitivityValue(this.props.indicatorName);
        const { t } = this.props;
        let badLabel = this.props.badLabel === undefined ? t('sensitivity.bad') : this.props.badLabel;
        let criticalLabel = this.props.criticalLabel === undefined ? t('sensitivity.critical') : this.props.criticalLabel;
        return [
            <div key={"full-period-" + this.props.indicatorName + "-medium"} className="form-item" style={{width:"50%"}}>
                <label>{badLabel}</label>
                <div style={{display: "flex", alignItems: "center"}}>
                    <input onChange={this.handleMediumSensitivityChange}
                       readOnly={'readonly' ? !this.props.isActive : ''}
                       className={this.classNameForSensitivityInput()}
                       value={badSensitivityValue}
                       name={this.props.indicatorName + '-medium'} type="number" placeholder=""/><span style={{marginLeft: "4px"}}>{this.props.sensitivityUnit}</span>
                </div>
            </div>,
            <div key={"full-period-" + this.props.indicatorName + "-high"} className="form-item" style={{width:"50%"}}>
                <label>{criticalLabel}</label>
                <div style={{display: "flex", alignItems: "center"}}>
                    <input onChange={this.handleHighSensitivityChange}
                           readOnly={'readonly' ? !this.props.isActive : ''}
                           className={this.classNameForSensitivityInput()}
                           value={criticSensitivityValue}
                           name={this.props.indicatorName + '-high'} type="number" placeholder=""/><span
                    style={{marginLeft: "4px"}}>{this.props.sensitivityUnit}</span>
                </div>
            </div>
        ]
    }

    renderSensitivitiesForFunds() {
        const { t } = this.props;
        let badSensitivityValue = this.badSensitivityValue(this.props.indicatorName);

        let criticSensitivityValue = this.criticSensitivityValue(this.props.indicatorName);
        return [
            <div key={"full-period-" + this.props.indicatorName + "-medium"} className="form-item" style={{width:"130px"}}>
                <label>{t('two_level_indicator_sensitivity.warning')}</label>
                <div style={{display: "flex", alignItems: "center"}}>
                    <input onChange={this.handleMediumSensitivityChange}
                           readOnly={'readonly' ? !this.props.isActive : ''}
                           className={this.classNameForSensitivityInput()}
                           value={badSensitivityValue}
                           name={this.props.indicatorName + '-medium'} type="number" placeholder=""/><span
                    style={{marginLeft: "4px"}}>{this.props.sensitivityUnit}</span>
                </div>
            </div>,
            <div key={"full-period-" + this.props.indicatorName + "-high"} className="form-item">
                <label>{t('two_level_indicator_sensitivity.critical')}</label>
                <div style={{display: "flex", alignItems: "center"}}>
                    <input onChange={this.handleHighSensitivityChange}
                           readOnly={'readonly' ? !this.props.isActive : ''}
                           className={this.classNameForSensitivityInput()}
                           value={criticSensitivityValue}
                           name={this.props.indicatorName + '-high'} type="number" placeholder=""/><span
                    style={{marginLeft: "4px"}}>{this.props.sensitivityUnit}</span>
                </div>
            </div>
        ]
    }

    classNameForSensitivityInput() {
        return 'form-control very-small';
    }

    renderSensitivitiesForIndicatorsWithGoodAndBad() {
        const { t } = this.props;
        return [
            <div key={"full-period-" + this.props.indicatorName + "-medium"} className="form-item" style={{width:"50%"}}>
                <label>{t('two_level_indicator_sensitivity.bad_good')}</label>
                <div style={{display: "flex", alignItems: "center"}}>
                    <input onChange={this.handleMediumSensitivityChange}
                           readOnly={'readonly' ? !this.props.isActive : ''}
                           className={this.classNameForSensitivityInput()}
                           value={this.badSensitivityValue(this.props.indicatorName)}
                           name={this.props.indicatorName + '-medium'} type="text" placeholder=""/><span
                    style={{marginLeft: "4px"}}>{this.props.sensitivityUnit}</span>
                </div>
            </div>,
            <div key={"full-period-" + this.props.indicatorName + "-high"} className="form-item" style={{width:"50%"}}>
                <label>{t('two_level_indicator_sensitivity.critical_successful')}</label>
                <div style={{display: "flex", alignItems: "center"}}>
                    <input onChange={this.handleHighSensitivityChange}
                           readOnly={'readonly' ? !this.props.isActive : ''}
                           className={this.classNameForSensitivityInput()}
                           value={this.criticSensitivityValue(this.props.indicatorName)}
                           name={this.props.indicatorName + '-high'} type="text" placeholder=""/><span
                    style={{marginLeft: "4px"}}>{this.props.sensitivityUnit}</span>
                </div>
            </div>
        ]
    }

    indicatorIsFunds() {
        return this.props.indicatorName === FUNDS_INDICATOR;
    }

    indicatorIsGoals() {
        return this.props.indicatorName === GOAL_1_INDICATOR || this.props.indicatorName === GOAL_2_INDICATOR;
    }

    indicatorIsFlexIndicator() {
        return this.props.indicatorName.includes(AGENCY_FLEX_INDICATOR);
    }

    indicatorIsBudgetOrODS() {
        return this.props.indicatorName === BUDGET_PROPORTIONAL_DAILY_INDICATOR
            || this.props.indicatorName === COST_VS_PROJECTED_INDICATOR
            || this.props.indicatorName === CURRENT_PERIOD_COST_VS_TIME_COMPLETION_INDICATOR
            || this.props.indicatorName === ODS_VS_YESTERDAY_INDICATOR
            || this.props.indicatorName === ODS_VS_LAST_7_DAYS_INDICATOR
            || this.props.indicatorName === ODS_VS_TODAY_INDICATOR
            || this.props.indicatorName === ODS_VS_PLATFORM_BUDGET_INDICATOR
            || this.props.indicatorName === EXCEED_BUDGET_INDICATOR;
    }

    indicatorIsConversionsOrCPA() {
        return this.props.indicatorName === CONVERSIONS_DAILY_INDICATOR || CPA_INDICATORS.includes(this.props.indicatorName) || this.props.indicatorName === CURRENT_ROAS_VS_LAST_MONTH || this.props.indicatorName === CURRENT_ACOS_VS_LAST_MONTH;
    }

    handleMediumSensitivityChange(event) {
        let target = event.target;

        if (this.indicatorIsConversionsOrCPA() || this.indicatorIsGoals() || this.indicatorIsFlexIndicator()) {
            this.props.handleSensitivityChange(this.props.indicatorName, 'GOOD', target.value);
            this.props.handleSensitivityChange(this.props.indicatorName, 'BAD', target.value);
        } else if (this.indicatorIsBudgetOrODS() || this.indicatorIsFunds()) {
            this.props.handleSensitivityChange(this.props.indicatorName, 'BAD', target.value);
        }
    }

    handleHighSensitivityChange(event) {
        let target = event.target;
        if (this.indicatorIsConversionsOrCPA() || this.indicatorIsGoals() || this.indicatorIsFlexIndicator()) {
            this.props.handleSensitivityChange(this.props.indicatorName, 'SUCCESS', target.value);
            this.props.handleSensitivityChange(this.props.indicatorName, 'CRITIC', target.value);
        } else if (this.indicatorIsBudgetOrODS() || this.indicatorIsFunds()) {
            this.props.handleSensitivityChange(this.props.indicatorName, 'CRITIC', target.value);
        }
    }

    handleStatusChange(event) {
        let target = event.target;
        let shouldActivate = target.checked;

        this.props.handleStatusChange(this.props.indicatorName, shouldActivate)
    }
}

export const TwoLevelIndicatorSensitivity = withTranslation()(TwoLevelIndicatorSensitivityComponent);
